import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { actions, selectors } from 'src/store';
import { paths } from 'src/constants';
import { useIntlMessages } from 'src/hooks';

import { Container } from './components';

const ClimbStepTwoExtraCollections = ({
  climbStepTwoExtraCollections,
  climbStepTwoExtraCurrency,
  getCollections,
  hasLoaded,
  student,
}) => {
  const messages = useIntlMessages();

  return (
    <Container
      className="climb-collections-container--step-two-extra"
      currency={climbStepTwoExtraCurrency}
      getCollections={getCollections}
      hasLoaded={hasLoaded}
      items={climbStepTwoExtraCollections}
      levelsPath={paths.CLIMB_STEP_TWO_EXTRA_LEVELS}
      student={student}
      title={messages.subactivity.climbStepTwoExtra}
    />
  );
};

ClimbStepTwoExtraCollections.propTypes = {
  climbStepTwoExtraCollections: PropTypes.arrayOf(PropTypes.shape({}))
    .isRequired,
  climbStepTwoExtraCurrency: PropTypes.shape({}).isRequired,
  getCollections: PropTypes.func.isRequired,
  hasLoaded: PropTypes.bool.isRequired,
  student: PropTypes.shape({}).isRequired,
};

const mapStateToProps = (state) => ({
  hasLoaded: selectors.climbStepTwoExtraCollections.getHasLoaded(state),
  climbStepTwoExtraCollections: selectors.climbStepTwoExtraCollections.getCollectionsData(
    state
  ),
  climbStepTwoExtraCurrency: selectors.climbStepTwoExtraCollections.getCurrencyData(
    state
  ),
  student: selectors.authentication.getStudent(state),
});

const mapDispatchToProps = {
  ...actions.climbStepTwoExtra,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  memo
)(ClimbStepTwoExtraCollections);
